import { render, staticRenderFns } from "./AuthorHandle.vue?vue&type=template&id=00556b25&scoped=true"
import script from "./AuthorHandle.vue?vue&type=script&lang=js"
export * from "./AuthorHandle.vue?vue&type=script&lang=js"
import style0 from "./AuthorHandle.vue?vue&type=style&index=0&id=00556b25&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00556b25",
  null
  
)

export default component.exports